<template>
  <router-view />
</template>

<script>
export default {
  mounted() {
    window.document.title = this.$t('app.clientSpacePHL');
  },
};
</script>
<style>
@import url("https://fonts.cdnfonts.com/css/poppins");

/* ── Charte graphique PHL Soft ── couleur principale #c4165a ── */
:root {
  --primary-color: #c4165a !important;
  --primary-color-text: #ffffff !important;
  --focus-ring: 0 0 0 0.2rem rgba(196, 22, 90, 0.35) !important;
  --highlight-bg: #fce8f0 !important;
  --highlight-text-color: #c4165a !important;
}

/* Boutons remplis */
.p-button { background: #c4165a !important; border-color: #c4165a !important; }
.p-button:hover, .p-button:active { background: #a31249 !important; border-color: #a31249 !important; }
.p-button:focus { box-shadow: 0 0 0 0.2rem rgba(196,22,90,0.35) !important; }

/* Boutons outlined */
.p-button.p-button-outlined { background: transparent !important; color: #c4165a !important; border-color: #c4165a !important; }
.p-button.p-button-outlined:hover { background: rgba(196,22,90,0.06) !important; }

/* Boutons texte / link */
.p-button.p-button-text, .p-button.p-button-link { color: #c4165a !important; background: transparent !important; border-color: transparent !important; }
.p-button.p-button-text:hover, .p-button.p-button-link:hover { background: rgba(196,22,90,0.06) !important; }

/* Tabs actifs */
.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link { border-color: #c4165a !important; color: #c4165a !important; }
.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link:focus { box-shadow: inset 0 0 0 0.2rem rgba(196,22,90,0.2) !important; }

/* Inputs focus */
.p-inputtext:focus, .p-inputtext.p-focus { border-color: #c4165a !important; box-shadow: 0 0 0 0.2rem rgba(196,22,90,0.2) !important; }
.p-dropdown:focus, .p-dropdown.p-focus, .p-dropdown:not(.p-disabled).p-focus { border-color: #c4165a !important; box-shadow: 0 0 0 0.2rem rgba(196,22,90,0.2) !important; }
.p-multiselect:not(.p-disabled).p-focus { border-color: #c4165a !important; box-shadow: 0 0 0 0.2rem rgba(196,22,90,0.2) !important; }

/* Checkbox & Radio */
.p-checkbox .p-checkbox-box.p-highlight { background: #c4165a !important; border-color: #c4165a !important; }
.p-checkbox .p-checkbox-box.p-highlight:hover { background: #a31249 !important; border-color: #a31249 !important; }
.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-focus { box-shadow: 0 0 0 0.2rem rgba(196,22,90,0.2) !important; border-color: #c4165a !important; }
.p-radiobutton .p-radiobutton-box.p-highlight { border-color: #c4165a !important; background: #c4165a !important; }
.p-radiobutton .p-radiobutton-box.p-highlight .p-radiobutton-icon { background: #ffffff !important; }
.p-radiobutton:not(.p-radiobutton-disabled) .p-radiobutton-box:hover { border-color: #c4165a !important; }
.p-radiobutton:not(.p-radiobutton-disabled) .p-radiobutton-box.p-focus { box-shadow: 0 0 0 0.2rem rgba(196,22,90,0.2) !important; border-color: #c4165a !important; }

/* Pagination active */
.p-paginator .p-paginator-pages .p-paginator-page.p-highlight { background: #fce8f0 !important; border-color: #fce8f0 !important; color: #c4165a !important; }

/* Tags primary */
.p-tag.p-tag-primary, .p-badge.p-badge-primary { background: #c4165a !important; }

/* Highlight (dropdown option selected, etc.) */
.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight { background: #fce8f0 !important; color: #c4165a !important; }
.p-listbox .p-listbox-list .p-listbox-item.p-highlight { background: #fce8f0 !important; color: #c4165a !important; }
.p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight { background: #fce8f0 !important; color: #c4165a !important; }

/* DataTable row selected / sort icon */
.p-datatable .p-sortable-column.p-highlight { color: #c4165a !important; }
.p-datatable .p-sortable-column.p-highlight .p-sortable-column-icon { color: #c4165a !important; }
.p-datatable .p-sortable-column:focus { box-shadow: inset 0 0 0 0.15rem rgba(196,22,90,0.2) !important; }

/* ProgressBar */
.p-progressbar .p-progressbar-value { background: #c4165a !important; }

/* Links / anchors PrimeVue */
a.p-menuitem-link:hover, .p-menuitem.p-highlight > .p-menuitem-link { color: #c4165a !important; }

/* Lara-light-blue hardcoded overrides — focus rings and input borders */
.p-inputtext:enabled:hover { border-color: #c4165a !important; }
.p-inputtext:enabled:focus { border-color: #c4165a !important; box-shadow: 0 0 0 0.2rem rgba(196,22,90,0.2) !important; }
.p-dropdown:not(.p-disabled):hover { border-color: #c4165a !important; }
.p-multiselect:not(.p-disabled):hover { border-color: #c4165a !important; }
.p-calendar:not(.p-disabled):hover .p-inputtext { border-color: #c4165a !important; }
.p-inputnumber:not(.p-disabled):hover .p-inputtext { border-color: #c4165a !important; }
.p-password:not(.p-disabled):hover .p-inputtext { border-color: #c4165a !important; }
.p-chips:not(.p-disabled):hover .p-inputtext { border-color: #c4165a !important; }
.p-autocomplete:not(.p-disabled):hover .p-inputtext { border-color: #c4165a !important; }
.p-treeselect:not(.p-disabled):hover { border-color: #c4165a !important; }
.p-password.p-focus > .p-inputtext { border-color: #c4165a !important; box-shadow: 0 0 0 0.2rem rgba(196,22,90,0.2) !important; }
.p-inputnumber.p-inputwrapper-focus .p-inputtext { border-color: #c4165a !important; box-shadow: 0 0 0 0.2rem rgba(196,22,90,0.2) !important; }
.p-autocomplete.p-focus > .p-inputtext { border-color: #c4165a !important; }
.p-chips.p-focus > .p-inputtext { border-color: #c4165a !important; }
.p-treeselect.p-focus { border-color: #c4165a !important; box-shadow: 0 0 0 0.2rem rgba(196,22,90,0.2) !important; }
.p-calendar.p-inputwrapper-focus .p-inputtext { border-color: #c4165a !important; box-shadow: 0 0 0 0.2rem rgba(196,22,90,0.2) !important; }
.p-calendar:not(.p-disabled).p-focus { border-color: #c4165a !important; }

/* Lara selection highlight background */
::selection { background: rgba(196,22,90,0.2); }

/* Action icons in DataTables */
.pi-action { color: #c4165a; font-size: 1.5rem; }

/* text-primary inside rendered HTML (ticket body) */
.text-primary { color: #c4165a !important; }

/* Cancel buttons — cyan → white text (on pink p-button background) */
.border-cyan-500 { border-color: #c4165a !important; }
.text-cyan-500 { color: #ffffff !important; }

/* Override PrimeFlex blue/indigo utility classes globally */
.bg-blue-500 { background-color: #c4165a !important; }
.hover\:bg-blue-700:hover { background-color: #8c0e40 !important; }
.bg-blue-100 { background-color: #fce8f0 !important; }
.border-blue-200 { border-color: #f5b8d0 !important; }
.text-blue-900 { color: #5a0020 !important; }
.border-blue-500 { border-color: #c4165a !important; }
.bg-indigo-500 { background-color: #c4165a !important; }
.border-indigo-500 { border-color: #c4165a !important; }
.hover\:bg-indigo-500:hover { background-color: #c4165a !important; }

body {
  font-family: "poppins" !important;
  margin: 0;
}
.gradientArmonie {
  background: #8c0e40;
  background: linear-gradient(
    90deg,
    #8c0e40 0%,
    #c4165a 50%,
    #e84481 100%
  );
}
.bg-gradientArmonie:hover {
  background: #8c0e40;
  background: linear-gradient(
    90deg,
    #8c0e40 0%,
    #c4165a 50%,
    #e84481 100%
  );
}
.poppins {
  font-family: "poppins" !important;
}
</style>
